import { PARAMETER_EMBEDDING_TARGET_NAME } from '@disy/lib.backend/api-constants';

import type { WorkbookEmbeddingTargetId } from 'cadenza/repository/model/workbook-embedding-target-id.gen';
import { getStore } from 'cadenza/store/cadenza-store';
import { getEmbeddingTargetById } from 'cadenza/workbook/workbook-core-selectors.state';

/**
 * @return Whether the current page is a view embedding target
 */
export function isEmbeddedView() {
  return getEmbeddingTarget()?.viewId != null;
}

/**
 * @return Whether the current content (workbook, worksheet, view) is an embedding target
 */
export function isEmbeddedContent() {
  return getEmbeddingTarget()?.workbookName != null;
}

export function getEmbeddingTarget() {
  const embeddingTargetId = new URLSearchParams(location.search).get(PARAMETER_EMBEDDING_TARGET_NAME);
  if (embeddingTargetId) {
    return getEmbeddingTargetById(getStore().getState(), embeddingTargetId as WorkbookEmbeddingTargetId);
  }
}
